import { fireLinkTag } from './tagManager';

const getBaseEventName = (isSearching) => {
  const state = isSearching ? 'typing state' : 'zero state';
  return `ask ai:open chat:search bar:${state}`;
};

export const tagStaticPromptClick = (isSearching) => {
  const eventName = getBaseEventName(isSearching);
  fireLinkTag({
    event_name: eventName,
    link_name: eventName,
  });
};

export const tagDynamicPromptClick = (isSearching) => {
  const eventName = `${getBaseEventName(isSearching)}:suggested prompt`;
  fireLinkTag({
    event_name: eventName,
    link_name: eventName,
  });
};

export default {
  tagStaticPromptClick,
  tagDynamicPromptClick,
};
